import {
  AppBarEvents,
  AppBarImpressionAppData,
} from "@1js/office-start-appbar-events";
import { useNovaEventing } from "@nova/react";
import React from "react";
import { AppBarItem } from "./AppBarContext.types";
import useAppBarContext from "./hooks/useAppBarContext";
export interface AppBarImpressionProps {
  impressionStabilizeTimeout?: number;
}
export const AppBarImpression: React.FC<AppBarImpressionProps> = ({
  impressionStabilizeTimeout = 5000,
}) => {
  const [impressionTriggered, setImpressionTriggered] = React.useState(false);
  const [impressionReady, setImpressionReady] = React.useState(false);
  const [impressionRecorded, setImpressionRecorded] = React.useState(false);
  const novaEventing = useNovaEventing();
  const appBarContext = useAppBarContext();
  React.useEffect(() => {
    if (!impressionTriggered && appBarContext.appBarData?.m365Apps) {
      setImpressionTriggered(true);
      // Give it some time to stabilize, then fire the impression event
      setTimeout(() => {
        setImpressionReady(true);
      }, impressionStabilizeTimeout);
    }
  }, [
    impressionTriggered,
    appBarContext.appBarData?.m365Apps,
    impressionStabilizeTimeout,
  ]);
  React.useEffect(() => {
    if (impressionReady && !impressionRecorded) {
      setImpressionRecorded(true);
      // Fire a Nova event
      const convertItem = (item: AppBarItem) => {
        return (
          item &&
          ({
            id: item.data.node.id,
            platformType: item.data.node.platformType,
          } as AppBarImpressionAppData)
        );
      };
      const convertItems = (items: AppBarItem[] | undefined) =>
        items ? items.map(convertItem) : [];
      const appBarImpressionEvent = AppBarEvents.appBarImpression(() => {
        return {
          lockedTiles: convertItems(appBarContext.lockedItems),
          pinnedTiles: convertItems(appBarContext.pinnedItems),
          hoistedTile: appBarContext.hoistedItem
            ? convertItem(appBarContext.hoistedItem)
            : undefined,
          overflowTiles: convertItems(appBarContext.overflowItems),
        };
      });
      novaEventing.generateEvent({
        event: appBarImpressionEvent,
      });
    }
  }, [novaEventing, impressionReady, impressionRecorded, appBarContext]);
  return null;
};
